import {
    CONFIRMED_CREATE_SCRIPT_ACTION,
    CONFIRMED_DELETE_SCRIPT_ACTION,
    CONFIRMED_EDIT_SCRIPT_ACTION,
    CONFIRMED_GET_SCRIPT
  } from "./ScriptTypes"
  import {
    getScriptList,
    addScript,
    editScript,
    deleteScript,
    formatScriptList
  } from "../../services/ScriptService"
  import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService"
  
  export function getScriptListAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by="",sort_order="") {
    return async (dispatch) => {
      try {
        const response = await getScriptList(pagination, pageid,search_by,search_keyword,sort_by,sort_order)
        if (response?.status === 200 && response?.data?.status === "success") {
          const scriptList = formatScriptList(response.data.data);

          dispatch({
            type: CONFIRMED_GET_SCRIPT,
            payload: {
              list: scriptList,
              numRows: response.data.numRows, // ✅ IMPORTANT
            },
          });
          return { success: true, data: scriptList }
        } else {
          throw new Error(response?.data?.message || "Failed to fetch Script")
        }
      } catch (error) {
        console.error("Get script list error:", error)
        //dispatch({ type: "FAILED_GET_CONTENT", payload: error.message })
        showErrorAlert(error.message || "Failed to fetch script")
        throw error
      }
    }
  }
 
  
  export function createScriptAction(scriptData) {
    return async (dispatch) => {
      try {
        const response = await addScript(scriptData)
        if (response?.status === 200 && response?.data?.status === "success") {
          handleSuccess("Success!", "Script added successfully!")
          dispatch({ type: CONFIRMED_CREATE_SCRIPT_ACTION, payload: response.data.data })
          return { success: true, data: response.data.data }
        } else {
          throw new Error(response?.data?.message || "Failed to add script")
        }
      } catch (error) {
        console.error("Add script error:", error)
        showErrorAlert(error.message || "Failed to add script")
        throw error
      }
    }
  }
  
  export function editScriptAction(scriptData) {
    return async (dispatch) => {
      try {
        const response = await editScript(scriptData)
        console.log("Edit script response:", response.data.data)

        if (response?.status === 200 && response?.data?.status === "success") {
          handleSuccess("Success!", "Script updated successfully!")
          dispatch({ type: CONFIRMED_EDIT_SCRIPT_ACTION, payload: response.data.data })
          return { success: true, data: response.data.data }
        } else {
          throw new Error(response?.data?.message || "Failed to update script")
        }
      } catch (error) {
        console.error("Edit script error:", error)
        showErrorAlert(error.message || "Failed to update script")
        throw error
      }
    }
  }
  
  export function deleteScriptAction(scriptId) {
    return async (dispatch) => {
      try {
        const response = await deleteScript(scriptId)
        if (response?.data?.status === "success") {
          dispatch({
            type: CONFIRMED_DELETE_SCRIPT_ACTION,
            payload: { script_id: scriptId },
          })
          handleSuccess("Script deleted successfully!")
          return { success: true, script_id: scriptId }
        } else {
          throw new Error(response?.data?.message || "Failed to delete script")
        }
      } catch (error) {
        console.error("Delete script error:", error)
        //dispatch({ type: "FAILED_DELETE_CONTENT", payload: error.message })
        showErrorAlert(error.message || "Failed to delete script")
        throw error
      }
    }
  }
  